import { useMediaQuery } from "./useMediaQuery";

export function useWorkspaceLayout() {
  return {
    isSidebarDocked: useMediaQuery("(min-width: 768px)"),
    isChatDocked: useMediaQuery("(min-width: 1024px)")
  };
}
